import { useEffect } from 'react';

const OPEN_EVENT = 'feedback-prompt:open';

interface OpenRequestDetail {
   surface: string;
}

export function requestFeedbackPrompt(surface: string): void {
   if (typeof window === 'undefined') {
      return;
   }

   window.dispatchEvent(new CustomEvent<OpenRequestDetail>(OPEN_EVENT, { detail: { surface } }));
}

export function useFeedbackOpenRequest(surface: string, onRequest: () => void): void {
   useEffect(() => {
      const handle = (event: Event) => {
         const detail = (event as CustomEvent<OpenRequestDetail>).detail;
         if (detail?.surface === surface) {
            onRequest();
         }
      };

      window.addEventListener(OPEN_EVENT, handle);
      return () => window.removeEventListener(OPEN_EVENT, handle);
   }, [surface, onRequest]);
}
